import React, { Component } from "react";
import "./style.css";
import { connect } from "react-redux";
import Modal from '@material-ui/core/Modal';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import { Button, ButtonGroup } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import ComponentFormNatural from './componentNatural';
import ComponentFormJuridico from './componentJuridico';
import ComponentFormDomestico from './componentDomestico';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { PDFDocument, rgb } from 'pdf-lib';


import {
  getActiveStep,
  getSnackBar,
  getDynamicOptions,
  getFormInitialized,
  getFormFiles,
  getDynamicDisable,
  getFormValid,
  getMessage,
  getOpenModalDireccion,
  getEstadoAfiliacionCompany,
  getModalFlujos,
  getNameAnexos,
  getCambioStado,
  getPopSeeAnexos,
  getModalNumProcess,
  getOpenModalCharged,
  getOpenModalFinal,
  getEmpleadorType,
  getbase64Add,
  getActiveFormRya,
  getBase64Unique,
  getStepLimite,
  getModalFinalForm,
  getCorregimientoForm,
  getModalFormReg,
  getSolicitudes,
  getCatalogosCargados,
  getCatalogCompleted,
  getRevisePantalla,
  getMessageConfirmation,
  getIdAppForm,
  getPopUpFormPdf,
  getErrorTryCatch,
  getOpenMondalTryCatch,
  getChangeComponentId,
  getModalDeleteContact,
  getMessageEsperaData,
} from "./selectors";

import {
  UPDATE_FIELD_ATTRIBUTE,
  INCREASE_STEP,
  SALVAR_STEP,
  DECREASE_STEP,
  HANDLE_STEP,
  OPEN_FINAL_MODAL,
  LOAD_CATALOG,
  CLOSE_MODAL_DIRECCION,
  CREATE_DIRECCION_MODAL,
  OPEN_MODAL_DIRECCION,
  getAfiliacionCompanyForm,
  VALIDA_AFILIACION_COMPANY,
  getAfiliacionButtons,
  GESTION_PERSONAL_ADMIN,
  FORM_NAME_STEP_PRINCIPAL,
  CLOSE_MODAL_FLUJOS,
  REQUIRED_FORM_PRINCIPAL,
  UPLOAD_ANEXOS,
  REMOVE_ANEXOS,
  SEE_ANEXOS,
  CLOSED_POPUP_ADJUNTOS,
  getModalNumProcesos,
  FORM_NAME_NUM_PROCESS,
  CLOSE_MODAL_NUM_PROCESS,
  VALIDATE_NUM_PROCESS,
  getAddSend,
  CLOSE_MODAL_FINAL,
  TITTLE_ENCABEZADO,
  ACTIVE_FORM_RYA,
  EXPORT_BASE64_UNIQUE,
  FORMULARIO_OF_COMERCIAL,
  INFO_USER_COMERCIAL,
  getModalForm,
  FORM_NAME_DIRECCION,
  getAddCancel,
  getModalFormDir,
  OPEN_MODAL_FORMULARIO_REG,
  INIT_CATALOG_COMPLETED,
  VALIDATE_ERRORS_FORMAT,
  VEFICATED_CHANGES_FROM_BANDEJA,
  RETURN_TO_HOME,
  OPEN_MODAL_RETURN_HOME,
  CLOSE_MODAL_RETURN_HOME,
  CLOSE_MODAL_ACEPT_PDF,
  GESTIONA_MODAL_TRY_CATCH,
  DELETE_CONTACTO_EXISTS_STEP4,
  SUBTITTLE_ENCABEZADO,
  CLOSE_MODAL,
  CLEAN_FORM_CACHE,
} from "./constants";

import CustomForm from "../../components/materialform/customform";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

import LoginButton from "../../components/authlogin/authlogin";
import { getFromSession } from "../../controller/session";
import { isUndefined } from "lodash-es";
import { validateDireccion, validateStepPrincipal } from "./controllerEmpresas";
import { decode, emptyJson, generatePDFbUtil } from "../../controller/utils";
import { initialize } from "redux-form";

class ComponentLargeForm extends Component {

  componentWillUnmount() {
    const { cleanForm } = this.props;
    cleanForm();
  }

  componentDidMount() {
    const { loadCatalog, params, formularioCustomer, saveInfoUserComercial } = this.props;
    const paramUrl = decode(window.location.search.slice(1)).split('&').reduce((acc, s) => {
      const [k, v] = s.split('=')
      return Object.assign(acc, { [k]: v })
    }, {})

    if (paramUrl.formulario)
      formularioCustomer(paramUrl)
    else
      saveInfoUserComercial({ userInfo: params.userInfo ? params.userInfo : false });
    loadCatalog({ params: params.form ? params.form : false });

  }


  componentDidUpdate(prevProps) {
    const { activeStep, params, initializeRevisaPantalla, revisePantalla, catalogCharged, handleStep,
      catalogCompleted, dynamicOptions, initCatalogCompleted, itemsForm, stepLimite, base64Add, activeFormRyA,
      updateActivateFormRyA, base64Unique } = this.props;
    if (params && params.form) {
      if (params.stepForm >= 0 && params.stepForm !== prevProps.activeStep && params.stepForm !== activeStep) {
        handleStep(params.stepForm)
      }
      if (!activeFormRyA)
        updateActivateFormRyA();

      if (revisePantalla)
        initializeRevisaPantalla(itemsForm);

      if (stepLimite && params.stepFinal === false)
        params.setStepFinal(stepLimite);
      if (base64Add && base64Add.length > 0 && !params.anexosCharged) {
        params.setItemsForm(itemsForm)
        params.setAnexos(base64Add);
        params.setCatalog(catalogCharged)
        params.setAnexosCharged(true);

      }
    }
    if (activeStep !== prevProps.activeStep) {
      // document.body.scrollTop = -100;
      // document.documentElement.scrollTop = -100;
      window.scrollTo(0, 0);
    }
    if (dynamicOptions !== false && catalogCompleted === false) {
      initCatalogCompleted()
    }

  }


  validatePrincipal = (values) => {
    const { validateErrors } = this.props;
    let errors = validateStepPrincipal(values)

    if (emptyJson(errors.afiliacionEmpresas)) {
      validateErrors({ type: "stepPrincipal", state: false });
    } else {
      validateErrors({ type: "stepPrincipal", state: true });
    }
    return errors;
  };

  showSnackBar(open, message) {
    return (
      <Snackbar open={open} autoHideDuration={1} className="ocultar">
        <Alert severity="success">{message}</Alert>
      </Snackbar>
    );
  }

  modalTryCatch(message) {
    const { closeModalTryCatch } = this.props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            <Alert className="alert danger">
              {message}
            </Alert>
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalTryCatch()}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }

  modalSubmitValid(props) {
    const { modalFlujos, closeModalFlujos } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            {modalFlujos.error ?
              <Alert className="alert danger">
                {modalFlujos.message}
              </Alert>
              :
              <Alert className="alertsucessBorrador" >
                {modalFlujos.message}
              </Alert>
            }
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalFlujos({ row: modalFlujos.row ? modalFlujos.row : false })}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }

  modalConfirmacion(props) {
    const { messageConfirmation, returnToHome, closeModalReturnHome } = props;
    return (
      <div >
        <Dialog
          className="modal-confirmation"
          open
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Información</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
            //tabIndex={-1}
            >
              {messageConfirmation.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGroup color="primary" aria-label="primary button group">
              <Button
                onClick={() => closeModalReturnHome()}
              >
                Cancelar
              </Button>


              <Button onClick={() => window.location.reload()}>
                Aceptar
              </Button>

            </ButtonGroup>

          </DialogActions>
        </Dialog>
      </div>
    );
  }

  modalIdForm(props) {
    const { modalFormReg, closeModalFormReg } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            <Alert className="alertsucessBorrador" >
              <p>{modalFormReg.message}</p><p className="idFormMessage">{modalFormReg.form}</p> <p>{modalFormReg.messageFinal}</p>
            </Alert>
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalFormReg()}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }


  modalSubmitValidFinal(props) {
    const { modalFinalForm } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            {modalFinalForm.error ?
              <Alert className="alert danger">
                {modalFinalForm.message}
              </Alert>
              :
              <Alert className="alertsucessBorrador" >
                {modalFinalForm.message}
              </Alert>
            }
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => window.location.reload()}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }

  modalSubmitValidDeleteContacto(props) {
    const { modalDeleteContact, actionDeleteContact } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>

            <Alert className="alert danger">
              {modalDeleteContact.message}
            </Alert>


          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => actionDeleteContact({ name: "aceptar", data: modalDeleteContact.data })}
            >
              Aceptar
            </Button>

            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => actionDeleteContact({ name: "cancelar" })}>
              Cancelar
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  modalNumeroProceso(props) {
    const { validarNumProcess, closeModalNumProcess, dynamicOptions } = props;

    return (
      <div className="modalProcessNum">
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open
        >
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getModalNumProcesos()}
              formName={FORM_NAME_NUM_PROCESS}
              //validations={this.validateStep6}
              handleSubmit={() => validarNumProcess()}
              buttons={getAddSend(
                () => closeModalNumProcess(),
                () => validarNumProcess()
              )}
              dynamicOptions={dynamicOptions}
              className="formProcessNum"
            />
          </React.Fragment>


        </Modal>
      </div>
    );
  }

  modalEsperaCharged() {

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="modalEsperaCharged">
          <CircularProgress style={{ width: '70px', height: '70px' }} />
        </div>
      </Modal>
    );
  }

  getStepPrincipal(props) {
    const { validaAfiliacion, dynamicOptions, validateErrors, changeComponentId } = props;

    return (
      <React.Fragment>
        <CustomForm
          submitable={false}
          items={getAfiliacionCompanyForm()}
          formName={FORM_NAME_STEP_PRINCIPAL}
          validations={this.validatePrincipal}
          handleSubmit={() => validaAfiliacion()}
          buttons={getAfiliacionButtons(() => validaAfiliacion)}
          dynamicOptions={dynamicOptions}
          changeComponentId={changeComponentId}
          // dynamicDisable={dynamicDisable}
          className="people-form"
        />
      </React.Fragment>
    );
  }

  modalCreateDireccion(props) {
    const { closeModalDireccion, createDireccionModal, dynamicOptions, corregimientoForm } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        disableScrollLock
        open
        className="createDireccionModal"
      >

        <React.Fragment>
          <CustomForm
            submitable={false}
            items={corregimientoForm ? getModalFormDir() : getModalForm()}
            formName={FORM_NAME_DIRECCION}
            validations={validateDireccion}
            handleSubmit={() => createDireccionModal()}
            buttons={getAddCancel(
              () => closeModalDireccion(),
              () => createDireccionModal()
            )}
            dynamicOptions={dynamicOptions}
            // dynamicDisable={dynamicDisable}
            className="modalDireccion"
          />
        </React.Fragment>


      </Modal>
    );
  }

  modalSubmitConfirmation(props) {
    const { closeModalFinal, submitFinalForm, formFiles } = props;
    return (
      <Dialog
        open
        className="modal-submit-basica-form"
      >
        <div className="finalForm">
          <h2>Finalizar formulario</h2>
        </div>
        <DialogActions>
          <Button
            className='buttonFinalizar'
            variant="text"
            color="default"
            onClick={() => closeModalFinal()}
          >
            Cerrar
          </Button>
          <Button
            className='buttonFinalizar'
            variant="text"
            color="default"
            onClick={() => submitFinalForm({ formFiles, final: true })}
          >
            Finalizar
          </Button>

        </DialogActions>
      </Dialog>
    );
  }

  modalVizualicePDF(props) {
    const { popUpFormPdf, closeModalVizualicePDF, acceptPdfPotulation } = props;
    return (
      <div >
        <Dialog
          className="modal-confirmation"
          open
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Postulación</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
            //tabIndex={-1}
            >
              <h3 className="ask-pdf">
                El archivo pdf representa la información registrada para su empresa, ¿Está de acuerdo con los datos registrados?
              </h3>
              {popUpFormPdf.type.includes("pdf") ?
                <object className="objAnexo" data={`data:application/pdf;base64,${popUpFormPdf.data}`} type="application/pdf" ></object>
                :
                <img className="objAnexo" src={`data:image/${popUpFormPdf.type};base64,${popUpFormPdf.data}`} />
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGroup color="primary" aria-label="primary button group">
              <Button
                onClick={() => closeModalVizualicePDF()}
              >
                Cancelar
              </Button>


              <Button onClick={() => acceptPdfPotulation()}>
                Aceptar
              </Button>

            </ButtonGroup>

          </DialogActions>
        </Dialog>
      </div>
    );
  }

  modalSeeAdjuntos(props) {
    const { popSeeAnexos, closeModalAdjuntos } = props;
    return (
      <div className="modalSeeAdjuntos">
        <Dialog
          open
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Anexos</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
            //tabIndex={-1}
            >
              {popSeeAnexos.file.type.includes("pdf") ?
                <embed className="objAnexo" src={`https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${popSeeAnexos.file.refFile}`} width="100%" />
                :
                <img className="objAnexo" src={`https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${popSeeAnexos.file.refFile}`} />
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalAdjuntos()}
            >
              Cerrar
            </Button>

          </DialogActions>
        </Dialog>
      </div>
    );
  }
  // generatePDF(base64String) {
  //   generatePDFbUtil(base64String)
  // };

  modalRevisandoExcelRelationsWorkers(props) {

    const { messageEsperaData, closeModal, savedActionsValidation } = props;

    return (
      <div >
        <Dialog
          className="modal-confirmation"
          open
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Información</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
            //tabIndex={-1}
            >
              {!messageEsperaData.valid ? messageEsperaData.message : "Estamos procesando tu archivo"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGroup color="primary" aria-label="primary button group">
              <Button
                onClick={() => closeModal("cancela")}
              >
                Cancelar
              </Button>


              <Button onClick={() => closeModal("acepta")}>
                Aceptar
              </Button>

            </ButtonGroup>

          </DialogActions>
        </Dialog>
      </div>
    );
  }

  render() {
    const {
      formInitialized,
      openModalDireccion,
      estadoAfiliacionCompany,
      modalFlujos,
      modalNumProcess,
      openModalCharged,
      empleadorType,
      modalFinalForm,
      modalFormReg,
      openModalReturnHome,
      messageConfirmation,
      activeFormRya,
      idAppForm,
      popUpFormPdf,
      errorTryCatch,
      openMondalTryCatch,
      modalDeleteContact,
      popSeeAnexos,
      messageEsperaData,
    } = this.props;

    const authUser = getFromSession('authUser');


    if (!formInitialized && authUser) {

    }

    return (
      <div className="App auth-container">
        {openMondalTryCatch ? this.modalTryCatch(errorTryCatch) : ""}
        <h1 className="AppEncabezado">{TITTLE_ENCABEZADO}</h1>
        <h2 className="subtitleEncabezado">{SUBTITTLE_ENCABEZADO}</h2>
        {openModalDireccion ? this.modalCreateDireccion(this.props) : ""}
        {modalNumProcess ? this.modalNumeroProceso(this.props) : ""}

        {openModalCharged ? this.modalEsperaCharged() : ""}
        {modalFlujos.open ? this.modalSubmitValid(this.props) : ''}
        {modalFormReg.open ? this.modalIdForm(this.props) : ''}
        {popUpFormPdf.open ? this.modalVizualicePDF(this.props) : ''}
        {!modalFinalForm ? "" : this.modalSubmitValidFinal(this.props)}
        {modalDeleteContact.open && this.modalSubmitValidDeleteContacto(this.props)}
        {messageConfirmation.open ? this.modalConfirmacion(this.props) : ""}
        {popSeeAnexos.open ? this.modalSeeAdjuntos(this.props) : ""}
        {messageEsperaData && this.modalRevisandoExcelRelationsWorkers(this.props)}
        {estadoAfiliacionCompany === false ? this.getStepPrincipal(this.props) :
          <React.Fragment>
            {empleadorType === "3" ? //DOMESTICOS
              (<ComponentFormDomestico params={this.props} />)
              : empleadorType === "1" ? //JURIDICAS
                (<ComponentFormJuridico params={this.props} />)
                :
                empleadorType === "2" ? //NATURAL
                  (<ComponentFormNatural params={this.props} />)
                  : ""}
            {activeFormRya ? "" :
              idAppForm.idOportunidad ?
                <div className="button-wrapper-form">
                  <ButtonGroup color="primary" aria-label="primary button group">
                    <Button onClick={() => openModalReturnHome({ open: true, message: "¿Está seguro de salir del proceso de afiliación? Recuerde que puede retomar el proceso, ingresando el número de registro generado al inicio de la afiliación el cual se envió al correo electrónico registrado." })}>
                      Salir
                    </Button>
                  </ButtonGroup>

                </div>
                : ""
            }
          </React.Fragment>
        }
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    activeStep: getActiveStep(state),
    showSnackBar: getSnackBar(state),
    dynamicOptions: getDynamicOptions(state),
    dynamicDisable: getDynamicDisable(state),
    formInitialized: getFormInitialized(state),
    formFiles: getFormFiles(state),
    message: getMessage(state),
    modalFinalForm: getModalFinalForm(state),
    formValid: getFormValid(state),
    openModalDireccion: getOpenModalDireccion(state),
    estadoAfiliacionCompany: getEstadoAfiliacionCompany(state),
    modalFlujos: getModalFlujos(state),
    nameAnexos: getNameAnexos(state),
    newEstado: getCambioStado(state),
    popSeeAnexos: getPopSeeAnexos(state),
    modalNumProcess: getModalNumProcess(state),
    openModalCharged: getOpenModalCharged(state),
    openModalFinal: getOpenModalFinal(state),
    dynamicDisable: getDynamicDisable(state),
    empleadorType: getEmpleadorType(state),
    base64Add: getbase64Add(state),
    activeFormRyA: getActiveFormRya(state),
    base64Unique: getBase64Unique(state),
    stepLimite: getStepLimite(state),
    corregimientoForm: getCorregimientoForm(state),
    modalFormReg: getModalFormReg(state),
    itemsForm: getSolicitudes(state),
    catalogCharged: getCatalogosCargados(state),
    catalogCompleted: getCatalogCompleted(state),
    revisePantalla: getRevisePantalla(state),
    messageConfirmation: getMessageConfirmation(state),
    activeFormRya: getActiveFormRya(state),
    idAppForm: getIdAppForm(state),
    popUpFormPdf: getPopUpFormPdf(state),
    errorTryCatch: getErrorTryCatch(state),
    openMondalTryCatch: getOpenMondalTryCatch(state),
    changeComponentId: getChangeComponentId(state),
    modalDeleteContact: getModalDeleteContact(state),
    messageEsperaData: getMessageEsperaData(state),
  };
};

const mapDispachToProps = (dispatch) => {
  return {
    cleanForm: (value) => dispatch({ type: CLEAN_FORM_CACHE, value }),
    initCatalogCompleted: (value) => dispatch({ type: INIT_CATALOG_COMPLETED, value: { start: true } }),
    updateAttributes: (value) => dispatch({ type: UPDATE_FIELD_ATTRIBUTE, value }),
    updateActivateFormRyA: (value) => dispatch({ type: ACTIVE_FORM_RYA, value }),
    updateBase64Unique: (value) => dispatch({ type: EXPORT_BASE64_UNIQUE, value }),
    increaseStep: (value) => dispatch({ type: INCREASE_STEP, value }),
    salvarStep: (value) => dispatch({ type: SALVAR_STEP, value }),
    decreaseStep: (value) => dispatch({ type: DECREASE_STEP, value }),
    handleStep: (value) => dispatch({ type: HANDLE_STEP, value }),
    openSubmitModal: (value) => dispatch({ type: OPEN_FINAL_MODAL, value }),
    loadCatalog: (value) => dispatch({ type: LOAD_CATALOG, value }),
    closeModalDireccion: (value) => dispatch({ type: CLOSE_MODAL_DIRECCION, value }),
    createDireccionModal: (value) => dispatch({ type: CREATE_DIRECCION_MODAL, value }),
    modalDireccion: (value) => dispatch({ type: OPEN_MODAL_DIRECCION, value }),
    validaAfiliacion: (value) => dispatch({ type: VALIDA_AFILIACION_COMPANY, value }),
    closeModalFlujos: (value) => dispatch({ type: CLOSE_MODAL_FLUJOS, value }),
    handleUploadAnexo: (value) => dispatch({ type: UPLOAD_ANEXOS, value }),
    handleRemoveAnexo: (value) => dispatch({ type: REMOVE_ANEXOS, value }),
    handleSeeAnexo: (value) => dispatch({ type: SEE_ANEXOS, value }),
    closeModalAdjuntos: (value) => dispatch({ type: CLOSED_POPUP_ADJUNTOS, value }),
    closeModalNumProcess: (value) => dispatch({ type: CLOSE_MODAL_NUM_PROCESS, value }),
    closeModalFinal: (value) => dispatch({ type: CLOSE_MODAL_FINAL, value }),
    validarNumProcess: (value) => dispatch({ type: VALIDATE_NUM_PROCESS, value }),
    submitFinalForm: (value) => dispatch({ type: SALVAR_STEP, value }),
    formularioCustomer: (value) => dispatch({ type: FORMULARIO_OF_COMERCIAL, value }),
    saveInfoUserComercial: (value) => dispatch({ type: INFO_USER_COMERCIAL, value }),
    closeModalFormReg: (value) => dispatch({ type: OPEN_MODAL_FORMULARIO_REG, value: { close: true } }),
    validateErrors: (value) => dispatch({ type: VALIDATE_ERRORS_FORMAT, value }),
    initializeRevisaPantalla: (value) => dispatch({ type: VEFICATED_CHANGES_FROM_BANDEJA, value }),
    returnToHome: (value) => dispatch({ type: RETURN_TO_HOME, value }),
    openModalReturnHome: (value) => dispatch({ type: OPEN_MODAL_RETURN_HOME, value }),
    closeModalReturnHome: (value) => dispatch({ type: CLOSE_MODAL_RETURN_HOME, value }),
    closeModalVizualicePDF: (value) => dispatch({ type: CLOSE_MODAL_ACEPT_PDF, value }),
    acceptPdfPotulation: (value) => dispatch({ type: OPEN_FINAL_MODAL, value }),
    closeModalTryCatch: (value) => dispatch({ type: GESTIONA_MODAL_TRY_CATCH, value }),
    actionDeleteContact: (value) => dispatch({ type: DELETE_CONTACTO_EXISTS_STEP4, value }),
    closeModal: (value) => dispatch({ type: CLOSE_MODAL, value }),
  };
};

export default connect(mapStateToProps, mapDispachToProps)(ComponentLargeForm);
